'use client';

import {useState} from 'react';
import Image from 'next/image';

interface CompanyLogoProps {
  companyWebsite: string;
  companyName: string;
  size: number;
  className?: string;
  wrapperClassName?: string;
}

// Brandfetch doesn't always fail with a network error when it has no logo for
// a domain — it can also resolve to a zero-dimension image, which loads
// "successfully" and never fires onError. Catch both cases and hide the slot.
export function CompanyLogo({companyWebsite, companyName, size, className, wrapperClassName}: CompanyLogoProps) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;

  return (
    <div className={wrapperClassName}>
      <Image
        src={`https://cdn.brandfetch.io/${companyWebsite}?c=1idvO3y7zFCQvl4O4eh`}
        alt={`${companyName} logo`}
        width={size}
        height={size}
        className={className}
        unoptimized
        onError={() => setFailed(true)}
        onLoad={(e) => {
          if (e.currentTarget.naturalWidth === 0) setFailed(true);
        }}
      />
    </div>
  );
}
